(function () {
  document.querySelectorAll('[data-sova-video]').forEach(function (root) {
    var mode = root.getAttribute('data-mode') || 'ambient';
    var video = root.querySelector('video');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    if (mode === 'ambient' && video && !reduceMotion && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.25) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: [0, 0.25, 1] });
      io.observe(root);
    }

    function toEmbed(url) {
      var yt = url.match(/(?:youtube\.com\/.*[?&]v=|youtu\.be\/)([\w-]{6,})/);
      if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
      var vim = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vim) return 'https://player.vimeo.com/video/' + vim[1] + '?autoplay=1';
      return null;
    }

    var playBtn = root.querySelector('[data-sova-video-play]');
    if (playBtn) {
      playBtn.addEventListener('click', function () {
        var external = root.querySelector('[data-sova-video-external]');

        if (video) {
          video.muted = false;
          video.controls = true;
          root.classList.add('is-playing');
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
          return;
        }

        if (external) {
          var url = external.getAttribute('data-url') || '';
          var embed = toEmbed(url);
          if (!embed) return;
          var iframe = document.createElement('iframe');
          iframe.src = embed;
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', 'Video');
          external.innerHTML = '';
          external.appendChild(iframe);
          root.classList.add('is-playing');
        }
      });
    }

    var soundBtn = root.querySelector('[data-sova-video-sound]');
    if (soundBtn && video) {
      soundBtn.addEventListener('click', function () {
        var willUnmute = video.muted;
        video.muted = !willUnmute;
        soundBtn.setAttribute('aria-pressed', willUnmute ? 'true' : 'false');
        soundBtn.setAttribute('aria-label', willUnmute ? 'Mute video' : 'Unmute video');
        if (willUnmute && video.paused) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      });
    }
  });
})();
